/**
 * CROSS-SELL COMPONENT - COMPLETE EXTERNAL VERSION
 * Preserves ALL original currency formatting with multi-currency support
 */

(function() {
  'use strict';
  
  // Get section data from inline script
  function getSectionData(sectionElement) {
    var sectionId = sectionElement.getAttribute('data-section-id');
    if (!sectionId) return null;
    
    if (window.crosssellData && window.crosssellData[sectionId]) {
      return window.crosssellData[sectionId];
    }
    
    return {
      sectionId: sectionId,
      productId: parseInt(sectionElement.getAttribute('data-product-id') || '0'),
      basePrice: parseInt(sectionElement.getAttribute('data-base-price') || '0'),
      shopCurrency: sectionElement.getAttribute('data-shop-currency') || 'USD'
    };
  }
  
  function initAll() {
    var crosssellContainers = document.querySelectorAll('[data-crosssell-section]');
    crosssellContainers.forEach(function(container) {
      if (container.hasAttribute('data-initialized')) return;
      var data = getSectionData(container);
      if (!data) return;
      container.setAttribute('data-initialized', 'true');
      initCrosssell(container, data);
    });
  }
  
  function initCrosssell(container, data) {
    var SECTION_ID = data.sectionId;
    var CURRENT_PRODUCT_ID = data.productId;
    var baseProductPriceCents = data.basePrice;
    var SHOP_CURRENCY = data.shopCurrency;
    var lastKnownATCPriceCents = baseProductPriceCents;
    var crosssellTotalCents = 0;
    var isOurUpdate = false;
    
    // ============================================================
    // COMPLETE CURRENCY SYMBOL MAPPING - MATCHES ORIGINAL
    // ============================================================
    
    var currencySymbols = {
      'USD': '$',
      'EUR': '€',
      'GBP': '£',
      'JPY': '¥',
      'CAD': 'C$',
      'AUD': 'A$',
      'CHF': 'CHF',
      'HUF': 'Ft',
      'PLN': 'zł',
      'CZK': 'Kč',
      'SEK': 'kr',
      'NOK': 'kr',
      'DKK': 'kr',
      'INR': '₹',
      'BRL': 'R$',
      'MXN': '$',
      'SGD': 'S$',
      'HKD': 'HK$',
      'NZD': 'NZ$',
      'ZAR': 'R',
      'RUB': '₽',
      'TRY': '₺',
      'UAH': '₴',
      'ILS': '₪',
      'THB': '฿',
      'KRW': '₩',
      'VND': '₫',
      'PHP': '₱',
      'IDR': 'Rp',
      'MYR': 'RM',
      'BGN': 'лв',
      'HRK': 'kn',
      'RON': 'lei'
    };
    
    // ============================================================
    // COMPLETE NUMBER FORMAT DETECTION - MATCHES ORIGINAL
    // ============================================================
    
    /**
     * Detect number format from a price string
     * Returns: 'us' (1,234.56), 'eu' (1.234,56), 'in' (1,23,456.78), 'none'
     */
    function detectNumberFormat(priceString) {
      if (!priceString) return 'us';
      
      var cleanPrice = String(priceString).trim();
      var commaCount = (cleanPrice.match(/,/g) || []).length;
      var dotCount = (cleanPrice.match(/\./g) || []).length;
      
      // No separators
      if (commaCount === 0 && dotCount === 0) {
        return 'none';
      }
      
      // Only one separator
      if (commaCount === 1 && dotCount === 0) {
        var lastCommaIdx = cleanPrice.lastIndexOf(',');
        var afterComma = cleanPrice.substring(lastCommaIdx + 1);
        return (afterComma.length === 3 || afterComma.length === 4) ? 'us' : 'eu';
      }
      
      if (commaCount === 0 && dotCount === 1) {
        return 'us';
      }
      
      // Multiple separators
      var lastCommaIdx = cleanPrice.lastIndexOf(',');
      var lastDotIdx = cleanPrice.lastIndexOf('.');
      
      if (lastDotIdx > lastCommaIdx) {
        return 'us';
      } else if (lastCommaIdx > lastDotIdx) {
        return 'eu';
      }
      
      if (commaCount > 1) {
        return 'in';
      }
      
      return 'us';
    }
    
    /**
     * Parse currency string to cents - EXACT MATCH TO ORIGINAL
     */
    function parseMoney(priceString) {
      if (!priceString) return 0;
      
      var cleaned = String(priceString).trim();
      
      // Remove all known currency symbols
      var symbols = ['$', '€', '£', '¥', 'kr', 'Ft', '₹', '₽', 'C$', 'A$', 'NZ$', 'S$', 'HK$', '₩', '฿', '₡', 'R$', 'zł', 'kč', '₺', '₴', '₪', '₫', '₱', 'Rp', 'RM', 'лв', 'kn', 'lei', 'CHF'];
      symbols.forEach(function(sym) {
        cleaned = cleaned.split(sym).join('');
      });
      
      // Remove 3-letter currency codes
      cleaned = cleaned.replace(/[A-Z]{3}/g, '');
      
      // Remove extra spaces
      cleaned = cleaned.trim().split(' ').join('');
      
      if (!cleaned || cleaned.match(/^[^\d]*$/)) {
        return 0;
      }
      
      var format = detectNumberFormat(cleaned);
      var normalized;
      
      if (format === 'eu') {
        // European: 1.234,56 → remove dots, replace comma with dot
        normalized = cleaned.replace(/\./g, '').replace(',', '.');
      } else if (format === 'in') {
        // Indian: 1,23,456.78 → remove all commas
        normalized = cleaned.replace(/,/g, '');
      } else if (format === 'none') {
        normalized = cleaned;
      } else {
        // US: 1,234.56 → remove commas
        normalized = cleaned.replace(/,/g, '');
      }
      
      var parsed = parseFloat(normalized);
      if (isNaN(parsed)) return 0;
      
      return Math.round(parsed * 100);
    }
    
    /**
     * Extract currency symbol from page - MATCHES ORIGINAL
     */
    function detectFormatFromPagePrice() {
      var priceElements = document.querySelectorAll('[data-product-price], #ProductPrice-' + SECTION_ID + ', .product-price .money, .money, [data-price], .atc-total-price');
      
      for (var i = 0; i < priceElements.length; i++) {
        var priceText = priceElements[i].textContent.trim();
        if (priceText && priceText.length > 2) {
          return {
            example: priceText,
            element: priceElements[i]
          };
        }
      }
      return null;
    }
    
    /**
     * Extract currency symbol from price string
     */
    function extractCurrencySymbol(priceString) {
      if (!priceString) return '';
      
      var symbols = ['$', '€', '£', '¥', 'kr', 'Ft', '₹', '₽', 'C$', 'A$', 'NZ$', 'S$', 'HK$', '₩', '฿', '₡', 'R$', 'zł', 'kč', '₺', '₴', '₪', '₫', '₱', 'Rp', 'RM', 'лв', 'kn', 'lei', 'CHF'];
      
      for (var i = 0; i < symbols.length; i++) {
        if (priceString.indexOf(symbols[i]) !== -1) {
          return symbols[i];
        }
      }
      
      var match = priceString.match(/[A-Z]{3}/);
      return match ? match[0] : '';
    }
    
    /**
     * Format cents to localized currency string - EXACT MATCH TO ORIGINAL
     */
    function formatMoney(cents) {
      if (!cents || cents === 0) return '0.00';
      
      var dollars = cents / 100;
      var pagePrice = detectFormatFromPagePrice();
      
      if (!pagePrice) {
        if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
          try {
            return Shopify.formatMoney(cents, '{{ shop.money_format }}');
          } catch(e) {
            return getCurrencySymbol() + dollars.toFixed(2);
          }
        }
        return getCurrencySymbol() + dollars.toFixed(2);
      }
      
      var examplePrice = pagePrice.example;
      var detectedFormat = detectNumberFormat(examplePrice);
      var currencySymbol = extractCurrencySymbol(examplePrice);
      
      if (!currencySymbol) {
        currencySymbol = getCurrencySymbol();
      }
      
      var formattedNumber;
      
      if (detectedFormat === 'eu') {
        // European format: 1.234,56
        formattedNumber = dollars.toLocaleString('de-DE', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        });
      } else if (detectedFormat === 'in') {
        // Indian format: 1,23,456.78
        formattedNumber = dollars.toLocaleString('en-IN', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        });
      } else {
        // US/Default format: 1,234.56
        formattedNumber = dollars.toLocaleString('en-US', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        });
      }
      
      // Determine symbol position
      var symbolPos = examplePrice.indexOf(currencySymbol);
      var firstDigitPos = examplePrice.search(/[\d,.\s]/);
      var symbolBefore = symbolPos < firstDigitPos;
      
      if (symbolBefore) {
        return currencySymbol + formattedNumber;
      } else {
        return formattedNumber + ' ' + currencySymbol;
      }
    }
    
    function getCurrencySymbol() {
      return currencySymbols[SHOP_CURRENCY] || SHOP_CURRENCY;
    }
    
    // ============================================================
    // CROSS-SELL CALCULATIONS - MATCHES ORIGINAL
    // ============================================================
    
    function getCrosssellTotal() {
      var total = 0;
      var mainPriceCents = parseMoney(document.querySelector('#ProductPrice-' + SECTION_ID)?.textContent || '0');
      var baseRatio = mainPriceCents > 0 ? mainPriceCents / baseProductPriceCents : 1;
      
      container.querySelectorAll('[data-crosssell-item]').forEach(function(item) {
        var qtyInput = item.querySelector('[data-quantity-input]');
        var qty = parseInt(qtyInput?.value) || 0;
        if (qty > 0) {
          var priceEl = item.querySelector('[data-item-price]');
          var priceInBaseCents = parseInt(priceEl?.getAttribute('data-item-price')) || 0;
          total += Math.round(priceInBaseCents * baseRatio) * qty;
        }
      });
      
      crosssellTotalCents = total;
      return total;
    }
    
    function getCrosssellQty() {
      var totalQty = 0;
      container.querySelectorAll('[data-crosssell-item]').forEach(function(item) {
        var qtyInput = item.querySelector('[data-quantity-input]');
        totalQty += parseInt(qtyInput?.value) || 0;
      });
      return totalQty;
    }
    
    function captureATCPrice() {
      var atcPrice = document.querySelector('.atc-total-price');
      if (atcPrice && atcPrice.style.display !== 'none') {
        var currentPrice = parseMoney(atcPrice.textContent);
        if (currentPrice > 0) {
          var expectedWithCrosssell = lastKnownATCPriceCents + crosssellTotalCents;
          if (currentPrice !== expectedWithCrosssell && currentPrice !== lastKnownATCPriceCents) {
            lastKnownATCPriceCents = currentPrice;
          }
        }
      }
    }
    
    // ============================================================
    // PRICE DISPLAY UPDATE
    // ============================================================
    
    function updateTotalPrice() {
      isOurUpdate = true;
      
      var currentCrosssellTotal = getCrosssellTotal();
      var crosssellQty = getCrosssellQty();
      var atcButton = document.querySelector('#AddToCart-' + SECTION_ID);
      
      if (!atcButton) {
        isOurUpdate = false;
        return;
      }
      
      var buttonTextSpan = atcButton.querySelector('#AddToCartText-' + SECTION_ID);
      var originalPriceSpan = atcButton.querySelector('.atc-total-price');
      var customPriceDisplay = atcButton.querySelector('.crosssell-total-price');
      
      if (crosssellQty > 0) {
        var grandTotal = lastKnownATCPriceCents + currentCrosssellTotal;
        var formattedPrice = formatMoney(grandTotal);
        
        if (originalPriceSpan) {
          originalPriceSpan.style.display = 'none';
        }
        
        if (!customPriceDisplay) {
          customPriceDisplay = document.createElement('span');
          customPriceDisplay.className = 'crosssell-total-price';
          if (buttonTextSpan) {
            buttonTextSpan.appendChild(customPriceDisplay);
          } else {
            atcButton.appendChild(customPriceDisplay);
          }
        }
        
        customPriceDisplay.style.display = 'inline';
        customPriceDisplay.textContent = '';
        
        var separator = document.createElement('span');
        separator.textContent = ' · ';
        separator.className = 'crosssell-separator';
        
        var priceSpan = document.createElement('span');
        priceSpan.textContent = formattedPrice;
        priceSpan.className = 'crosssell-price-amount';
        
        customPriceDisplay.appendChild(separator);
        customPriceDisplay.appendChild(priceSpan);
        
      } else {
        if (originalPriceSpan) {
          originalPriceSpan.style.display = '';
        }
        if (customPriceDisplay) {
          customPriceDisplay.style.display = 'none';
        }
      }
      
      setTimeout(function() {
        isOurUpdate = false;
      }, 100);
    }
    
    // ============================================================
    // CART OPERATIONS
    // ============================================================
    
    function updateCartCount() {
      fetch('/cart.js', { method: 'GET', headers: { 'Accept': 'application/json' } })
        .then(function(res) { return res.json(); })
        .then(function(cart) {
          var selectors = ['.cart-count', '.cart-item-count', '[data-cart-count]', '.cartCount', '.cart-count-bubble', '.site-header__cart-count', '.header__cart-count', '.cart-link__count', '.js-cart-count', '.cart__count', '#CartCount', '.cart-icon__count', '.header-cart-count', '.mini-cart__count', '.cart-quantity', '.header__icon-wrapper .count', '[data-cart-item-count]'];
          
          selectors.forEach(function(selector) {
            document.querySelectorAll(selector).forEach(function(el) {
              el.textContent = cart.item_count;
              el.classList.remove('hide', 'hidden', 'is-hidden');
              if (cart.item_count > 0) el.style.display = '';
            });
          });
          
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
        })
        .catch(function(err) { console.error('Cart count update failed:', err); });
    }
    
    // ============================================================
    // EVENT HANDLERS
    // ============================================================
    
    function findAddButtonForItem(item) {
      var variantId = item.getAttribute('data-variant-id');
      if (variantId) {
        return container.querySelector('.crosssell-item__action [data-add-to-cart][data-variant-id="' + variantId + '"]');
      }
      var nextSibling = item.nextElementSibling;
      if (nextSibling && nextSibling.classList.contains('crosssell-item__action')) {
        return nextSibling.querySelector('[data-add-to-cart]');
      }
      return null;
    }
    
    function findCrosssellItemForButton(addBtn) {
      var variantId = addBtn.getAttribute('data-variant-id');
      if (variantId) {
        return container.querySelector('[data-crosssell-item][data-variant-id="' + variantId + '"]');
      }
      var actionWrapper = addBtn.closest('.crosssell-item__action');
      if (actionWrapper) {
        var prevSibling = actionWrapper.previousElementSibling;
        if (prevSibling && prevSibling.hasAttribute('data-crosssell-item')) {
          return prevSibling;
        }
      }
      return null;
    }
    
    function updateAddButtonState(item) {
      var input = item.querySelector('[data-quantity-input]');
      var addBtn = findAddButtonForItem(item);
      if (addBtn) {
        if (parseInt(input.value) === 0) {
          addBtn.classList.add('is-disabled');
        } else {
          addBtn.classList.remove('is-disabled');
        }
      }
    }
    
    // ============================================================
    // INITIALIZATION
    // ============================================================
    
    // Hide self-referencing cross-sell items
    container.querySelectorAll('[data-crosssell-item]').forEach(function(item) {
      var itemProductId = item.getAttribute('data-product-id');
      if (itemProductId && parseInt(itemProductId) === CURRENT_PRODUCT_ID) {
        item.parentElement?.removeChild(item);
        var nextAction = item.nextElementSibling;
        if (nextAction && nextAction.classList.contains('crosssell-item__action')) {
          nextAction.parentElement?.removeChild(nextAction);
        }
      }
    });
    
    var visibleItems = container.querySelectorAll('[data-crosssell-item]');
    if (visibleItems.length === 0) {
      container.style.display = 'none';
      return;
    }
    
    // Event delegation for quantity buttons and add to cart
    container.addEventListener('click', function(e) {
      // Quantity buttons
      var qtyBtn = e.target.closest('[data-action]');
      if (qtyBtn && qtyBtn.closest('.quantity-selector')) {
        e.preventDefault();
        e.stopPropagation();
        
        var selector = qtyBtn.closest('.quantity-selector');
        var input = selector.querySelector('[data-quantity-input]');
        var currentValue = parseInt(input.value) || 0;
        var action = qtyBtn.getAttribute('data-action');
        
        if (action === 'increase') {
          var max = parseInt(input.max) || 10;
          if (currentValue < max) input.value = currentValue + 1;
        } else if (action === 'decrease') {
          if (currentValue > 0) input.value = currentValue - 1;
        }
        
        updateTotalPrice();
        updateAddButtonState(input.closest('[data-crosssell-item]'));
        return false;
      }
      
      // Add to cart buttons
      var addBtn = e.target.closest('[data-add-to-cart]');
      if (addBtn) {
        e.preventDefault();
        e.stopPropagation();
        
        var item = findCrosssellItemForButton(addBtn);
        if (!item) return false;
        
        var quantityInput = item.querySelector('[data-quantity-input]');
        var quantity = parseInt(quantityInput.value) || 0;
        if (quantity === 0) return false;
        
        var variantId = addBtn.dataset.variantId;
        addBtn.disabled = true;
        
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: parseInt(variantId), quantity: quantity })
        })
        .then(function(response) {
          return response.ok ? response.json() : response.json().then(function(err) {
            throw new Error(err.description || 'Failed to add to cart');
          });
        })
        .then(function() {
          addBtn.classList.add('is-added');
          quantityInput.value = 0;
          updateAddButtonState(item);
          updateTotalPrice();
          updateCartCount();
          setTimeout(function() {
            addBtn.classList.remove('is-added');
            addBtn.disabled = false;
          }, 3000);
        })
        .catch(function(err) {
          console.error('Add to cart error:', err);
          addBtn.disabled = false;
        });
        
        return false;
      }
    });
    
    // Input events
    container.querySelectorAll('[data-quantity-input]').forEach(function(input) {
      input.addEventListener('change', function() {
        updateTotalPrice();
        updateAddButtonState(input.closest('[data-crosssell-item]'));
      });
      input.addEventListener('input', updateTotalPrice);
    });
    
    // Initialize button states
    container.querySelectorAll('[data-crosssell-item]').forEach(function(item) {
      updateAddButtonState(item);
    });
    
    // Main product listeners
    function initMainProductListeners() {
      var mainQtyInput = document.querySelector('#quantity');
      if (mainQtyInput) {
        mainQtyInput.addEventListener('change', function() {
          captureATCPrice();
          updateTotalPrice();
        });
        mainQtyInput.addEventListener('input', function() {
          captureATCPrice();
          updateTotalPrice();
        });
      }
      
      document.querySelectorAll('.single-option-selector, .product-form__variants, .swatch input').forEach(function(selector) {
        selector.addEventListener('change', function() {
          setTimeout(function() { captureATCPrice(); updateTotalPrice(); }, 100);
          setTimeout(function() { captureATCPrice(); updateTotalPrice(); }, 300);
        });
      });
      
      // Watch ATC price element
      var atcPriceEl = document.querySelector('.atc-total-price');
      if (atcPriceEl) {
        var atcObserver = new MutationObserver(function() {
          if (isOurUpdate) return;
          if (getCrosssellQty() === 0) {
            captureATCPrice();
          } else {
            captureATCPrice();
            updateTotalPrice();
          }
        });
        atcObserver.observe(atcPriceEl, { characterData: true, childList: true, subtree: true });
      }
    }
    
    captureATCPrice();
    initMainProductListeners();
    updateTotalPrice();
  }
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  
  setTimeout(initAll, 500);
  setTimeout(initAll, 1000);
  setTimeout(initAll, 2000);
})();

// Move cross-sell section above product action
(function() {
  function moveCrosssell() {
    var crosssell = document.querySelector('[data-crosssell-section]');
    var productAction = document.querySelector('.product-action');
    if (crosssell && productAction && !crosssell.hasAttribute('data-moved')) {
      crosssell.setAttribute('data-moved', 'true');
      productAction.parentNode.insertBefore(crosssell, productAction);
    }
  }
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', moveCrosssell);
  } else {
    moveCrosssell();
  }
})();